export default "__VITE_ASSET__b87b4220__"